import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { RumiService } from 'src/app/services/rumi.service';
import { UtilitatsService } from 'src/app/services/utilitats.service';

@Component({
  selector: 'app-accions',
  templateUrl: './accions.component.html'
})
export class AccionsComponent implements OnInit {

  public get accions() {
    return this.rumiService.accions;
  }

  public get resultat() {
    return this.rumiService.simulacio.resultat;
  }

  constructor(
    public translate: TranslateService,
    private router: Router,
    private rumiService: RumiService,
    private utilService: UtilitatsService
  ) { }

  ngOnInit() {
    this.rumiService.pestanyaActiva = this.router.url;
  }

  goToPrevStep() {
    this.router.navigate(['simulacio','resultat-risc']);
  }

  imprimir() {
    this.utilService.showSpinner('Carregant informe...');
    this.rumiService.getInformeSimulacio().subscribe((res: Blob)=>{
      this.utilService.hideSpinner();
      var downloadURL = URL.createObjectURL(res);
      window.open(downloadURL).print();
    });
  }

}
